import { cn } from "@/lib/utils";
import { fmtUsd } from "@/lib/format";

export interface PnLPillProps {
  value: number | null | undefined;
  fractionDigits?: number;
  className?: string;
  asUsd?: boolean;
}

export function PnLPill({ value, fractionDigits = 2, className, asUsd = true }: PnLPillProps) {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return <span className={cn("tabular text-muted", className)}>-</span>;
  }
  const cls = value > 0 ? "text-good" : value < 0 ? "text-bad" : "text-muted";
  const display = asUsd
    ? fmtUsd(value, fractionDigits)
    : value.toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
  return <span className={cn("tabular font-medium", cls, className)}>{display}</span>;
}
